import React, { createContext, useContext, useReducer, ReactNode } from "react";
import { ContractDuration, AppContextProps, Routing } from "./file.interface";

type AppContextAction = {
  type: "UPDATE_CONTEXT";
  payload: Partial<AppContextProps>;
};

interface AppContextState extends AppContextProps {
  dispatch: React.Dispatch<AppContextAction>;
}

const AppContext = createContext<AppContextState | undefined>(undefined);

const initialState: AppContextProps = {
  routing: Routing.Epos,
  showModal: false,
  selectedIndustry: null,
  selectedPOSSolution: null,
  selectedContractDuration: ContractDuration.twoYears,
  flowDevices: [],
  flowAccessories: [],
  flowCardMachines: [],
  sites: [],
  sitesTotal: 0,
  isNewSite: false,
  selectedSiteFlow: 0,
  selectedDeliveryPackage: null,
  selectedProductConfPackage: null,
  selectedOngoingSupportPackage: null,
};

const appReducer = (
  state: AppContextProps,
  action: AppContextAction
): AppContextProps => {
  switch (action.type) {
    case "UPDATE_CONTEXT":
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

const AppContextProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [state, dispatch] = useReducer(appReducer, initialState);

  return (
    <AppContext.Provider value={{ ...state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
};

const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used within an AppContextProvider");
  }
  return context;
};

export { AppContextProvider, useAppContext };
